import React from 'react';
import { motion } from 'framer-motion';
import { MessageSquareIcon, CalendarCheckIcon, FileCheckIcon, RotateCcwIcon, UsersIcon, ClockIcon } from 'lucide-react';
import { SectionTag } from './SectionTag';
import { BENEFITS } from './salesData';
const ICONS = [MessageSquareIcon, CalendarCheckIcon, FileCheckIcon, RotateCcwIcon, UsersIcon, ClockIcon];
export function BenefitsSection() {
  return <section id="beneficios" className="bg-sand py-12 sm:py-16" data-id="element-52" data-mp="38r91n9im4b0x">
      <div className="mx-auto max-w-5xl px-5" data-id="element-53" data-mp="3dqvbd8z8f94z">
        <div className="text-center" data-id="element-54" data-mp="3dsojksphu1f3">
          <SectionTag data-id="element-55" data-mp="2zrc9gxx0ku14">Resultados</SectionTag>
          <h2 className="mt-4 font-display text-[1.5rem] font-bold uppercase leading-tight text-charcoal sm:text-[2.2rem]" data-id="element-56" data-mp="2zsnknissh429">
            Lo que cambia
            <span className="mt-1 block text-gold-deep" data-id="element-57" data-mp="xzzd4x943ugo">en tu consultorio</span>
          </h2>
        </div>

        <div className="mt-8 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-58" data-mp="12ysgvxylk73n">
          {BENEFITS.map((benefit, i) => {
          const Icon = ICONS[i % ICONS.length];
          return <motion.article key={benefit.title} initial={{
            opacity: 0,
            y: 14
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-40px'
          }} transition={{
            duration: 0.35,
            delay: i * 0.05
          }} className="h-full rounded-xl border border-stone bg-ivory p-5" data-id="element-59" data-mp="27dkc6o118bjn" data-mpi={i}>
                <span className="flex h-10 w-10 items-center justify-center rounded-lg bg-gold-soft" data-id="element-60" data-mp="1si4rh9mcdrzx">
                  <Icon className="h-5 w-5 text-gold-deep" aria-hidden data-id="element-61" data-mp="1oh2qoocs17vu" />
                </span>
                <h3 className="mt-3.5 font-display text-[0.9rem] font-bold uppercase leading-snug tracking-wide text-charcoal" data-id="element-62" data-mp="22c4rwy6oi92b">
                  {benefit.title}
                </h3>
                <p className="mt-1.5 font-sans text-[0.82rem] leading-relaxed text-charcoal/70" data-id="element-63" data-mp="3drtgtv3hti5r">
                  {benefit.desc}
                </p>
              </motion.article>;
        })}
        </div>
      </div>
    </section>;
}